
import { Component, OnDestroy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subject, concat, of } from 'rxjs';
import {
  takeUntil, startWith, filter, debounceTime, distinctUntilChanged,
  switchMap, tap, catchError
} from 'rxjs/operators';
import { ActiveDirectoryService } from 'src/app/core/active-directory.service';

@Component({
  selector: 'eos-ad-typeahead',
  template: `
  <ng-select [items]="options$ | async"
    bindLabel="displayName"
    [minTermLength]="3"
    typeToSearchText="Please enter 3 or more characters"
    [loading]="showLoader"
    [placeholder]="to.placeholder"
    [typeahead]="searchInput$"
    [formControl]="formControl">
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div><span>{{ item.displayName }}</span></div>
      <div><span><small>{{ item.userPrincipalName }}</small></span></div>
    </ng-template>
  </ng-select>
  `,
})
export class TypeaheadTypeComponent extends FieldType implements OnDestroy {
  private onDestroy$ = new Subject<void>();
  searchInput$ = new Subject<string>();
  options$;
  showLoader = false;

  constructor(private ad: ActiveDirectoryService) {
    super();
  }

  ngOnInit() {
    // Read initial config from templateOptions (keeps component generic)
    const initialSearchTerm: string = (this.to as any)?.initialSearchTerm || '';
    const autoSelect: boolean = !!(this.to as any)?.autoSelect;

    this.options$ = concat(
      of([]),
      this.searchInput$.pipe(
        takeUntil(this.onDestroy$),
        // Kick off a search immediately with the initial term
        startWith(initialSearchTerm),
        filter(v => !!v && v.length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => (this.showLoader = true)),
        switchMap(term =>
          this.ad.getAdUsers(term).pipe(
            catchError(() => of([])),
            tap(() => (this.showLoader = false))
          )
        ),
        // Auto-select matching option when results arrive
        // tap((options: any[]) => {
        //   if (!autoSelect || !Array.isArray(options) || options.length === 0) return;

        //   const wantedUpn: string = (this.to as any)?.initialUpn || '';
        //   const wantedName: string = (this.to as any)?.initialDisplayName || initialSearchTerm;

        //   const match =
        //     options.find(o => o?.userPrincipalName?.toLowerCase() === wantedUpn.toLowerCase()) ||
        //     options.find(o => o?.displayName?.toLowerCase() === wantedName.toLowerCase());

        //   if (match) {
        //     // Set full object (same as manual selection)
        //     this.formControl.setValue(match, { emitEvent: true });
        //     this.formControl.markAsDirty();
        //     this.formControl.markAsTouched();
        //     this.formControl.updateValueAndValidity({ emitEvent: true });
        //   }
        // })
      )
    );
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
